import React, { useEffect, useState } from 'react'
import { ListItemX2, PanelX1 } from '../../Components/Plugin'
import { Loader } from '../../Components/Shared'
import { ApiCall } from '../../Redux/Actions/ApiCall'
import { useSelector } from 'react-redux';
import { numberWithCommas } from '../../Components/numberWithCommas'


const Subscription = props => {

	const [items, setItems] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const token = useSelector(
		(state) => state.auth.token
	)


	useEffect(() => {
		setIsLoading(true)
		ApiCall(
			'GET',
			'/mobile/subscription',
			{},
			"response ->",
			token,
			res => {
				const responsiveData = res.data
				setItems(responsiveData.subscriptions)
				setIsLoading(false)
			},
			err => {
				setIsLoading(false)
			}
		)
	}, [])

	return (
		<>
			<div className="screenSubscription">
				{isLoading &&
					<Loader
						className="_loading"
						name="GridLoader"
						size={15}
						color="#f6c244"
					/>
				}
				{!isLoading && items.map((item, index) => {
					return (
						<PanelX1
							key={index}
							title={item.title}
							className="marginBottomNormalize"
						>
							<ListItemX2
								label={item.title}
								value={`هزینه : ${numberWithCommas(item.price)} ریال`}
								to={{
									pathname: '/subscriptionDetails',
									state: {
										item: item
									}
								}}
							/>
						</PanelX1>
					)
				})}
			</div>
		</>
	)

}


export default Subscription
